module.exports = {"511011001":"东兴街道","511011002":"西林街道","511011003":"新江街道","511011004":"胜利街道","511011005":"高桥街道","511011100":"田家镇","511011101":"郭北镇","511011102":"高梁镇","511011103":"白合镇","511011104":"顺河镇","511011107":"双才镇","511011108":"小河口镇","511011109":"杨家镇","511011110":"椑木镇","511011111":"石子镇","511011112":"椑南镇","511011113":"永兴镇","511011114":"平坦镇","511011115":"中山镇","511011116":"柳桥镇","511011117":"双桥镇","511011118":"富溪镇","511011119":"同福镇","511011120":"永福镇","511011121":"三烈镇","511011200":"太安乡","511011201":"苏家乡","511011207":"新店乡","511011211":"大治乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511011.json
// module id = 2323
// module chunks = 0